module.exports = __webpack_public_path__ + "static/media/Icons_History.cde134ad.svg";